import { jsx as _jsx } from "react/jsx-runtime";
import { StyledWrapper, StyledCardLink } from './styled';
export const CardLink = ({ children }) => _jsx(StyledCardLink, { children: children });
const Card = ({ fullHeight, to, children }) => (_jsx(StyledWrapper, Object.assign({ to: to, "$fullHeight": fullHeight }, { children: children })));
export default Card;
